export default __webpack_public_path__ + "static/media/bhavin.0f7ac1f7.png";